import { Badge } from '@/components/ui/badge';
import { config } from '@/utils/config';

// Always-visible footer answering "where am I pointed" regardless of the active
// tab. In dev the API is reached via the Vite proxy, so the target shown is the
// configured VITE_API_URL rather than the live axios baseURL.
const rows: [label: string, value: string][] = [
  ['API', config.API_URL],
  ['Keycloak', `${config.KEYCLOAK_REALM} @ ${config.KEYCLOAK_URL}`],
  ['Client', config.KEYCLOAK_CLIENT_ID],
];

export function EnvFooter() {
  const mode = import.meta.env.DEV ? 'dev' : 'prod';
  return (
    <div className="border-t border-border/50 bg-muted/30 px-5 py-3">
      <div className="mb-1.5 flex items-center gap-2">
        <span className="text-xs font-semibold text-muted-foreground">Environment</span>
        <Badge variant={mode === 'dev' ? 'secondary' : 'destructive'} className="uppercase">
          {mode}
        </Badge>
      </div>
      <dl className="flex flex-col gap-0.5">
        {rows.map(([label, value]) => (
          <div key={label} className="flex items-baseline gap-2 text-xs">
            <dt className="w-16 shrink-0 text-muted-foreground">{label}</dt>
            <dd className="min-w-0 flex-1 truncate font-mono text-[11px]" title={value}>
              {value}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
